import { render, staticRenderFns } from "./KeyValueModal.vue?vue&type=template&id=6b98035f&scoped=true"
import script from "./KeyValueModal.vue?vue&type=script&lang=js"
export * from "./KeyValueModal.vue?vue&type=script&lang=js"
import style0 from "./KeyValueModal.vue?vue&type=style&index=0&id=6b98035f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b98035f",
  null
  
)

export default component.exports